module.exports = __webpack_public_path__ + "index/img/1703344720899.6af734c3.png";